import * as React from "react"
import {BookingsSummary as BOOKINGS_SUMMARY, BookingsSummaryFragment} from "../graphql/queries"
import {Header, Loader, Table} from "semantic-ui-react"
import {GraphQL} from "../graphql"
import {errorUnionToEither, handleError} from "../graphql/errors"

interface Props {
  rows: Array<BookingsSummaryFragment>
}

function BookingsSummaryTable(props: Props) {
  return (
    <div>
      <Header as="h3">Bookings Summary</Header>
      <Table celled compact="very" fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Timezone</Table.HeaderCell>
            <Table.HeaderCell>Year</Table.HeaderCell>
            <Table.HeaderCell>Month</Table.HeaderCell>
            <Table.HeaderCell>Completed jobs</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {props.rows.map(({timeZoneId, year, month, completed}, index) => (
            <Table.Row key={index}>
              <Table.Cell>{timeZoneId}</Table.Cell>
              <Table.Cell>{year}</Table.Cell>
              <Table.Cell>{month}</Table.Cell>
              <Table.Cell>{completed}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  )
}

export function BookingsSummary() {
  return (
    <GraphQL.Query
      query={BOOKINGS_SUMMARY}
      variables={{}}
      fetchPolicy="cache-and-network"
      render={({data}) => {
        if (data) {
          return handleError(errorUnionToEither(data.bookingsSummary), (body) => (
            <BookingsSummaryTable rows={body.summary} />
          ))
        } else {
          return <Loader active />
        }
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingsSummary.tsx